const request = require('superagent');
import authService from './authService';
import userService from './userService';

const dataService = {
    request: ({ method, url, type, query }) => {
        let req = request(method, url)
            .accept(type)
            .query({
                ...query,
                auth_token: authService.getToken(),
                user_role: userService.getUserRole(),
            });
        return req;
    },
    postRequest: ({ url, type, query, key, value }) => {
        let req = request('POST', url)
            .accept(type)
            .query({
                ...query,
                auth_token: authService.getToken(),
                user_role: userService.getUserRole(),
            })
            .field(key,value);
        return req;
    }
}

export default dataService;